module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Subscribe to Sephora SMS',
        continueShopping: 'Continue Shopping',
        heading: 'We’re almost there. A text is on\nthe way. Reply Y to confirm.',
        checkYourSMS: `Check your SMS inbox at ${vars[0]} \nReply Y to subscribe and receive your 10% off code.`,
        disclaimerLine1: `By entering your phone number, clicking submit, and confirming sign-up, you consent to the ${vars[0]} and to receive recurring autodialed marketing texts. Message frequency varies. Consent is not a condition of purchase. Message & data rates may apply. See our ${vars[1]}. Text STOP to cancel at any time. HELP for help.`,
        textTerms: 'text terms',
        privacyPolicy: 'Privacy Policy'
    };

    return resources[label];
};
